<script setup>
const props = defineProps({
  signature: {
    type: Boolean,
    default: false,
  },
  button: {
    type: Object,
  },
  text: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <div class="row">
    <div class="col-12">
      <div
        class="d-flex justify-content-center justify-content-880-between hero"
      >
        <div class="hero__image hero__image--left">
          <img
            src="/images/cms/hero/Lucas.webp"
            alt="Lucas"
            class="hero__image"
            fetchpriority="high"
            srcset="
                            /images/cms/hero/Lucas-280.webp  280w,
                            /images/cms/hero/Lucas-340.webp  340w,
                            /images/cms/hero/Lucas-440.webp 440w,
                            /images/cms/hero/Lucas.webp     800w
                        "
            sizes="(max-width: 560px) 50vw, (max-width: 768px) 40vw, (max-width: 1024px) 35vw, (max-width: 1200px) 30vw, 440px"
          >
        </div>
        <div class="hero__image">
          <img
            src="/images/cms/hero/Marco.webp"
            alt="Marco"
            class="hero__image hero__image--left"
            fetchpriority="high"
            srcset="
                            /images/cms/hero/Marco-280.webp  280w,
                            /images/cms/hero/Marco-340.webp  340w,
                            /images/cms/hero/Marco-440.webp 440w,
                            /images/cms/hero/Marco.webp     800w
                        "
            sizes="(max-width: 560px) 50vw, (max-width: 768px) 40vw, (max-width: 1024px) 35vw, (max-width: 1200px) 30vw, 440px"
          >
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <div
          class="d-flex flex-column justify-content-center align-items-center content"
        >
          <div class="scale-1 scale-1--lead">
            <slot>{{ props.text }}</slot>
          </div>
          <img
            v-if="props.signature"
            src="/images/cms/hero/signature.svg"
            alt="signature"
            class="content__signature"
            loading="lazy"
          >
          <FormButton
            v-if="props.button?.label"
            class="l-button--outlined content__button"
            :label="props.button.label"
            :to="props.button.to"
            :rel="props.button.rel"
            component="NuxtLink"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
@import '@/node_modules/bootstrap/scss/mixins';

.hero {
  background: radial-gradient(rgba(210, 210, 210, 0.35) 0%, rgba(0, 0, 0, 1) 68%);
  background-position: center -20px;
  background-size: 100%;
  background-repeat: no-repeat;

  @include media-breakpoint-down(1200) {
    background-size: cover;

    // background overflow
    padding: 0 24px;
    margin: 0 -24px;
  }

  @include media-breakpoint-down(560) {
    padding: unset;
    margin: 0 $padding-container-negative;
  }

  &__image {
    overflow: hidden;
    padding: 0;

    img {
      display: block;
      height: clamp(204px, 18.33vw + 145.33px, 468px);
      width: 100%;
      aspect-ratio: auto 397/422;
      object-fit: contain;
      //safari fix:
      max-width: 430px;
      @include media-breakpoint-down(1360) {
        max-width: 400px;
      }
      @include media-breakpoint-down(1280) {
        max-width: 330px;
      }
      @include media-breakpoint-down(1040) {
        max-width: 280px;
      }

      @include media-breakpoint-down(800) {
        width: auto;
      }
    }
  }

  &__image--left {
    direction: rtl;
  }
}

.content {
  min-height: clamp(204px, 18.33vw + 145.33px, 468px);
  width: 100%;
  max-width: clamp(0px, 50vw + -160px, 720px);
  padding: 40px 0;
  margin-top: clamp(-468px, -18.33vw - 145.33px, -204px);
  text-align: center;

  @include media-breakpoint-down(1200) {
    width: 83%;
  }

  @include media-breakpoint-down(880) {
    min-height: unset;
    max-width: unset;
    padding: 0 0 40px 0;
    margin-top: -15px;
  }

  @include media-breakpoint-down(560) {
    margin-top: -10px;
    width: 100%;
  }

  &__signature {
    display: block;
    margin: 15px auto 0 auto;
    width: clamp(133px, 3.12vw + 123px, 178px);
    fill: $color-light;
    aspect-ratio: auto 85/19;
  }

  &__button {
    margin-top: 15px;
  }
}
</style>
